module.exports = __webpack_public_path__ + "img/朋友圈.52e41f50.png";